import React, { Fragment } from "react";
import { Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import {
  getFinalStatusWithModifiedDrStatuses,
  getStatusNameForConsolidatedReport,
} from "helpers/common";
import { lookupTable } from "data/data";
import moment from "moment";

const styles = StyleSheet.create({
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch",
    width: "100%",
    gap: "1%",
    marginBottom: "12px",
    paddingBottom: "12px",
    fontSize: "13",
    borderBottom: "2px solid #ad3919",
  },
  image: {
    width: "20%",
    display: "flex",
    flexDirection: "column",
    cursor: "pointer",
    gap: "10px",
    textAlign: "left",
  },
  patientName: {
    width: "30%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
  },
  status: {
    width: "50%",
    display: "flex",
    flexDirection: "column",
    textAlign: "left",
    justifyContent: "space-around",
    fontSize: "12px",
    padding: "10px",
  },
  rightLeftImages: {
    width: 60,
    height: 60,
    display: "flex",
    cursor: "pointer",
    margin: "5px 0px",
  },
  rightLeftImageNotAvailable: {
    width: 60,
    height: 60,
    display: "flex",
    cursor: "pointer",
    border: "1px solid black",
    margin: "5px 0px",
    justifyContent: "center",
    alignItems: "center",
  },
});

const TableRow = ({ items }) => {
  const getRegistrationTimeForTheBU = (dateAndTime) => {
    if (!dateAndTime) return [];
    const m = moment(dateAndTime);
    if (!m.isValid()) return [];
    // Format in the browser's local timezone (API sends UTC ISO with Z)
    return [m.format("YYYY-MM-DD"), ` ${m.format("h:mm A")}`];
  };
  console.log("Table ROw", items);
  const rows = items?.map((row, index) => (
    <View style={styles.row} key={index}>
      <View style={styles.patientName}>
        <Text>
          Name: {row.fname} {row.lname}
        </Text>
        <Text>Age: {row.age}</Text>
        <Text>Gender: {row.gender}</Text>
        <Text>
          Registered On:
          {getRegistrationTimeForTheBU(row.created_on).slice(0, 8)}
        </Text>
      </View>
      <View style={styles.image}>
        <View>
          <Text>Right</Text>
          {row.right?.thumbnailUrl ? (
            <Image
              source={row.right?.thumbnailUrl}
              style={styles.rightLeftImages}
            />
          ) : (
            <View style={styles.rightLeftImageNotAvailable}>
              <Text>NA</Text>
            </View>
          )}
        </View>
        <View>
          <Text>Left</Text>
          {row.left?.thumbnailUrl ? (
            <Image
              source={row.left?.thumbnailUrl}
              style={styles.rightLeftImages}
            />
          ) : (
            <View style={styles.rightLeftImageNotAvailable}>
              <Text>NA</Text>
            </View>
          )}
        </View>
      </View>
      <View style={styles.status}>
        <Text>RE: {getStatusNameForConsolidatedReport(row.right?.status)}</Text>
        <Text>LE: {getStatusNameForConsolidatedReport(row.left?.status)}</Text>
      </View>
    </View>
  ));
  return <Fragment>{rows}</Fragment>;
};

export default TableRow;
